export const mysqlDatetimeToJavascriptDatetime = (datetime) => {
  // Split timestamp into [ Y, M, D, h, m, s ]
  const t = datetime.split(/[- :]/);

  // Apply each element to the Date function
  return new Date(
    Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5])
  ).toISOString();
};
